const discount = {
  state: {
    show: false,
    src: ""
  }
};
export default discount;



// WEBPACK FOOTER //
// ./src/stroe/modules/iframe.js